import {
  FormControl as FormItemControl,
  FormLabel as FormItemLabel,
  Grid,
  RadioGroup as ItemGroup,
  Stack,
} from '@mui/material'
import FormCheckbox from 'components/FormControlCheckbox'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import Label from 'components/Label'
import React from 'react'
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { HearingIdentificationType, substances } from 'types/hearing-identification.type'
import { useHearingIdentificationBlockFieldsContext } from '../../../../../../contexts/hearing-identification-block-fields.context'

type SubstancesGroupProps = {
  control: Control<HearingIdentificationType>
  watch: UseFormWatch<HearingIdentificationType>
  setValue: UseFormSetValue<HearingIdentificationType>
}

export const SubstancesGroup: React.FC<SubstancesGroupProps> = ({ control, watch, setValue }) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()

  const isUsingSubstances = watch('identificacaoAdolescente.usaSubstancia')

  return (
    <>
      <Grid item xs={12}>
        <FormControlRadio
          control={control}
          name='identificacaoAdolescente.usaSubstancia'
          label='Faz uso de alguma substância? (Aqui perguntar se faz uso de alguma substância, bebida alcoólica, cigarro, drogas ilícitas)'
          options={radioButtonChoiceOptions}
          disabled={isBlockedFields}
        />
      </Grid>
      {isUsingSubstances === 'S' && (
        <Grid item xs={12}>
          <Stack direction='row'>
            <FormItemControl required={isUsingSubstances === 'S'}>
              <FormItemLabel
                id='substances-options-id'
                sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
              >
                <Label text='Se sim, quais?' sx={{ fontSize: 14, color: 'text.primary' }} />
              </FormItemLabel>
              <ItemGroup row>
                {substances.map((item, i) => (
                  <FormCheckbox
                    key={i}
                    control={control}
                    setValue={setValue}
                    name={`identificacaoAdolescente.${item.name}`}
                    label={item.label}
                  />
                ))}
              </ItemGroup>
            </FormItemControl>
          </Stack>
        </Grid>
      )}
    </>
  )
}
